import { AsyncPropSelector } from '@nile/components';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import { Popover, Button, ButtonGroup } from '@superops/ui-design-system';
import { Edit } from '@styled-icons/material/Edit';
import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { EditIcon } from '@nile/components/src/Icons';

const Field = styled.div`
  min-width: 200px;
  max-width: 250px;
  flex-grow: 1;
  padding-right: 10px;
  padding-left: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
`;

const Wrap = styled.div`
  display: flex;
  align-items: center;
  .edit-actions {
    visibility: hidden;
    cursor: pointer;
  }
  &:hover {
    .edit-actions {
      visibility: visible;
    }
  }
  padding-right: 8px;
  max-width: 100%;
  .ellipsis {
    white-space: nowrap;
  }
`;

const SelectCell = (props) => {
  const editable = props?.editable || false;
  const displayVal =
    (props?.property === 'owner'
      ? `${props?.value?.firstName} ${props?.value?.lastName}`
      : props?.value?.name) || 'NA';
  const [popoverActive, setPopoverActive] = useState(false);
  const [currentVal, setCurrentVal] = useState(props?.value || null);
  const togglePopoverActive = useCallback(() => {
    setPopoverActive(!popoverActive);
  });
  const activator = <EditIcon onClick={() => togglePopoverActive()} />;

  const onSaveAction = () => {
    const { name } = currentVal;
    const selectObj = {};
    if (props.property === 'owner') {
      selectObj.userId = currentVal.userId;
      selectObj.firstName = currentVal.firstName;
      selectObj.lastName = currentVal.lastName;
    } else {
      selectObj.name = currentVal.name;
      selectObj.id = currentVal?.id || currentVal?.value;
    }
    props.handleUpdate(props.property, selectObj);
    togglePopoverActive();
  };

  const onCancelAction = () => {
    togglePopoverActive();
  };

  return !popoverActive ? (
    <Wrap className={`${editable ? 'editable-cell' : 'cell'}`}>
      <div className="ellipsis" title={displayVal}>
        {displayVal ? (
          <div className="name ellipsis maxw200">{displayVal}</div>
        ) : (
          <DisabledTag>NA</DisabledTag>
        )}
      </div>
      {editable && <div className="edit-actions">{activator}</div>}
    </Wrap>
  ) : (
    <Wrap className="editable-cell">
      <div className="ellipsis" title={displayVal}>
        {displayVal ? (
          <div className="name ellipsis">{displayVal}</div>
        ) : (
          <DisabledTag>NA</DisabledTag>
        )}
      </div>
      <Popover
        activator={activator}
        active={popoverActive}
        onClose={() => {
          return;
          //togglePopoverActive()
        }}
      >
        <Field>
          <AsyncPropSelector
            defaultValue={
              props.property === 'owner'
                ? {
                    ...currentVal,
                    label: `${currentVal.firstName} ${currentVal.lastName}`,
                    value: `${currentVal.firstName} ${currentVal.lastName}`
                  }
                : {
                    ...currentVal,
                    label: currentVal.name,
                    value: currentVal.name
                  }
            }
            updateSelection={(field, val) => setCurrentVal(val)}
            field={props.allEntityFields.find(
              (field) => field.name === props.property
            )}
            entity="Project"
            variables={props?.variables}
            isDynamicQuery={props?.isDynamicQuery}
            dynamicQuery={props?.dynamicQuery}
            generateOptions={props?.generateOptions}
          />
          <div className="mt10">
            <ButtonGroup>
              <Button id="genCancelAction" onClick={onCancelAction}>
                <FormattedMessage id="common.cancel" />
              </Button>
              <Button id="genSaveAction" primary onClick={onSaveAction}>
                <FormattedMessage id="common.save" />
              </Button>
            </ButtonGroup>
          </div>
        </Field>
      </Popover>
    </Wrap>
  );
};

export default SelectCell;
